import { render } from "./FeatureComp.vue?vue&type=template&id=12da6694"
import script from "./FeatureComp.vue?vue&type=script&lang=js"
export * from "./FeatureComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__